import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useCreateDesignationMutation } from "../designationsApi";

const DesignationCreateModal = ({ show, onClose }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [createDesignation, { isLoading }] = useCreateDesignationMutation();

  const handleClose = () => {
    reset();
    onClose();
  };

  const onSubmit = async (values) => {
    try {
      await createDesignation({
        designationCode: values.designationCode.trim().toUpperCase(),
        designationName: values.designationName.trim(),
      }).unwrap();
      toast.success("Designation created");
      handleClose();
    } catch (error) {
      toast.error(error?.message || "Could not create designation");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Designation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Designation Code</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. GUARD"
              {...register("designationCode", { required: true })}
            />
            <small className="text-muted">
              Immutable once created - used as a stable key.
            </small>
            {errors.designationCode && (
              <div className="text-danger">Designation code is required</div>
            )}
          </div>
          <div className="mb-3">
            <label className="form-label">Designation Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="e.g. Guard"
              {...register("designationName", { required: true })}
            />
            {errors.designationName && (
              <div className="text-danger">Designation name is required</div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create Designation"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DesignationCreateModal;
